import React, { useEffect, useState } from 'react'
import { Button, Card, Col, DatePicker, Flex, Input, message, Modal, Row, Space, Table, Tag, Tooltip } from 'antd';
import { Grid } from "@mui/material";
import { DeleteFilled, EditFilled, ExportOutlined, FilterOutlined, InfoCircleTwoTone, PlusCircleFilled, SearchOutlined, UpSquareOutlined, UpSquareTwoTone } from '@ant-design/icons';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { showLoading, useLoadingDispatch, hideLoading } from '../../context/loadingContext';
import AuthService from '../../Components/auth/AuthService';
import moment from 'moment';
import { use } from 'react';
import { useSelector } from 'react-redux';
import { UpdateOutlined } from '@mui/icons-material';
import { showMessage } from '../../Components/Utils/message';
import { encodeId } from '../../Components/common/CommonFun';
import { DATE_FORMAT, DEFAULT_DATE_FORMAT, EXPIRATION_TIME } from '../../Components/common/Constants';
import { styled } from '@mui/system';
import ProductInfoModal from '../../Components/Modals/ProductInfoModal';
const DataSheet = styled('div')`
   .ant-card-body {
      padding: 10px;
    };
    .ant-card-head {
      min-height: 40px;
    };
`;
const Auth = new AuthService();

const CycleCountList = () => {
  const navigate = useNavigate();
  var layoutDispatch = useLoadingDispatch();
  const { products: allProducts } = useSelector((state) => state.AppState?.userCreds);
  const [cycleCounts, setCycleCounts] = useState([]);

  const [modalVisibleProduct, setModalVisibleProduct] = React.useState(false);
  const [selectedProductDetails, setSelectedProductDetails] = React.useState({
    totalStock: 0,
    code: '',
    name: '',
    productDetails: [],
    selectedRecord: null
  });
  const { RangePicker } = DatePicker
  const [filters, setFilters] = React.useState(() => {
    const existing = localStorage.getItem('CycleCountFilters');
    const parsed = existing ? JSON.parse(existing) : {};
    const currentTime = new Date().getTime();

    const defaultFilters = {
      dateRange: [dayjs().startOf("month"), dayjs().endOf("month")],
      batchCode: '',
    };

    if (parsed.timestamp && currentTime - parsed.timestamp < EXPIRATION_TIME) {
      if (parsed.dateRange) {
        parsed.dateRange = [
          parsed.dateRange[0] ? dayjs(parsed.dateRange[0]) : defaultFilters.dateRange[0],
          parsed.dateRange[1] ? dayjs(parsed.dateRange[1]) : defaultFilters.dateRange[1]
        ];
      }
      return { ...defaultFilters, ...parsed };
    }
    localStorage.removeItem('CycleCountFilters');
    return defaultFilters;
  });

  const updateFilters = (newValues) => {
    const existingString = localStorage.getItem('CycleCountFilters');
    const existing = existingString ? JSON.parse(existingString) : {};

    Object.assign(existing, newValues);
    existing.timestamp = new Date().getTime();

    localStorage.setItem('CycleCountFilters', JSON.stringify(existing));
  };

  const handleRowClick = (id) => {
    const hasedID = encodeId(id)

    navigate(`/cycle-counts/${hasedID}`)
  };
  const handleupdate = (id) => {
    const hasedID = encodeId(id)

    navigate(`/cycle-counts/update/${hasedID}`)
  };

  const deleteCycleCount = async (id) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/stock/cycle-count`, {
        method: "DELETE",
        body: JSON.stringify({ id: id })

      });
      if (res?.ack) {
        getCountCycles();
        showMessage('success', res?.message);
      } else {
        showMessage('error', res?.message);
      }
    } catch (err) {
      console.log(err);
      showMessage('error', err?.message);
    } finally {
      hideLoading(layoutDispatch);
    }
  };

  const handleModalCancelProduct = () => {
    setSelectedProductDetails({ ...selectedProductDetails, totalStock: 0, code: '', name: '', productDetails: [], selectedRecord: null });
    setModalVisibleProduct(false);
  }

  const handleInfoClick = async (product_id) => {
    const product = allProducts?.find((item) => item?.netsuite_id == product_id);
    showLoading(layoutDispatch)
    try {

      const res = await Auth.fetch(`/product/product-details?id=${product_id}`)
      if (res?.ack) {
        if (res?.product_details.length > 0) {
          const totalStock = res.product_details.reduce((sum, item) => sum + (Number(item.stock_level) || 0), 0);
          setSelectedProductDetails({ ...selectedProductDetails, totalStock: totalStock, code: product?.code, name: product?.name, productDetails: res?.product_details, selectedRecord: product });
          setModalVisibleProduct(true);
          hideLoading(layoutDispatch)

        } else {
          showMessage('error', 'No Details');
          hideLoading(layoutDispatch)
        }
      } else {
        setSelectedProductDetails({ ...selectedProductDetails, totalStock: 0, code: product?.code, name: product?.name, productDetails: [] });
        showMessage('error', res?.message)
        hideLoading(layoutDispatch)

      }

    } catch (error) {
      showMessage('error', 'something went wrong');
      hideLoading(layoutDispatch)
    }
  };

  const CycleColumns = [
    {
      title: 'Code',
      render: (record) => {
        return (
          <span>
            {record?.cycle_count_code ? record?.cycle_count_code : ""}
          </span>
        )
      },
      // width: 135,
    },
    {
      title: 'Date',
      render: (record) => {
        return (
          <span>
            {dayjs(record.count_date).format("DD-MM-YYYY")}
          </span>
        )
      },
      // width: 135,
    },
    {
      title: 'Products',
      render(record) {
        return (
          <Flex gap={2} wrap="wrap">
            {
              record?.products?.map((product, index) => (
                <Tag style={{ margin: 1, display: 'flex', alignItems: 'center', gap: 5 }} color="blue" key={index}>
                  <Tooltip title={'Product Info'}>
                    <InfoCircleTwoTone
                      style={{ fontSize: '18px', cursor: 'pointer' }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleInfoClick(product.product_id)
                      }}
                    />
                  </Tooltip>
                  {`${product?.product_code} - ${product?.product_name}`}
                </Tag>
              ))
            }
          </Flex>
        )
      },
      width: 400
    },


    {
      title: 'Action',
      key: 'action',
      align: "right",
      dataIndex: '',
      render(record) {
        return (
          <Flex gap={5} justify='end' onClick={(e) => e.stopPropagation()}>
            <ExportOutlined onClick={() => handleupdate(record.id)} style={{ fontSize: '25px', cursor: "pointer" }} />
            <EditFilled onClick={() => handleRowClick(record.id)} style={{ fontSize: '25px', cursor: "pointer", color: "#006cb8" }} />
            {
              !record?.posted_by > 0 && (
                <DeleteFilled style={
                  {
                    fontSize: "25px",
                    cursor: "pointer",
                    color: "#cd1437",
                  }} onClick={() => {
                    Modal.confirm({
                      title: 'Delete Cycle Count',
                      centered: true,
                      content: `Are you sure to delete this Cycle Count?`,
                      onOk: () => deleteCycleCount(record.id),
                      okText: 'Delete',
                      cancelText: 'Cancel',
                      width: 600,
                      okButtonProps: { size: "large" },
                      cancelButtonProps: { size: "large" },
                    });
                  }}
                />
              )
            }

          </Flex>
        );
      },
    },
  ];

  const getCountCycles = async () => {
    showLoading(layoutDispatch);
    const dataToSend = {
      //   limit: limit,
      //   page: page,
    }
    if (filters?.dateRange && filters?.dateRange[0] && filters?.dateRange[1]) {
      dataToSend.start_date = dayjs(filters?.dateRange[0]).format("YYYY-MM-DD");
      dataToSend.end_date = dayjs(filters?.dateRange[1]).format("YYYY-MM-DD");
    }
    try {
      const res = await Auth.post(`/stock/cycle-counts`, dataToSend);
      if (res?.ack) {
        console.log(res?.cycle_counts);
        const data = res?.cycle_counts
        const combined = data.reduce((acc, item) => {
          const productInfo = allProducts.find(p => p.netsuite_id === item.product_netsuite_id);
          const productObj = { product_id: item.product_netsuite_id, product_name: productInfo?.name, product_code: productInfo?.code };
          const existing = acc.find(entry => entry.id === item.id);

          if (existing) {
            existing.products.push(productObj);
          } else {
            acc.push({
              id: item.id,
              count_date: item.count_date,
              posted_by: item.posted_by,
              status: item.status,
              cycle_count_code: item.cycle_count_code,
              products: [productObj],
            });
          }

          return acc;
        }, []);

        setCycleCounts(combined);
      } else {
        setCycleCounts([]);
        showMessage('error', res?.message || 'No cycle counts found for the selected date range');
      }

    } catch (err) {
      console.log(err);
      showMessage('error', 'Something went wrong while fetching cycle counts');
      setCycleCounts([]);

    }
    finally {
      hideLoading(layoutDispatch);
    }
  }

  useEffect(() => {
    getCountCycles();
  }, [filters?.dateRange]);

  console.log('cycleCounts', cycleCounts);



  return (
    <DataSheet>
      <Card title={<><FilterOutlined style={{ color: '#6cb8ff'}}/> Cycle Counts</>}
        style={{ marginBottom: '10px' }}
        extra={
          <>
            <PlusCircleFilled style={{ fontSize: "30px", color: "#1677FF" }} onClick={() => navigate("/cycle-counts/new")} />
          </>
        }
      >
        <Row gutter={[6, 1]}>
          <Col xs={24} md={12} lg={8}>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '4px' }}>Date Range</label>
            <RangePicker
              style={{ width: '100%' }}
              value={filters.dateRange}
              onChange={(dates) => {
                setFilters(prev => ({ ...prev, dateRange: dates }));
                updateFilters({
                  dateRange: dates ? [dates[0] ? dates[0].format(DEFAULT_DATE_FORMAT) : null, dates[1] ? dates[1].format(DEFAULT_DATE_FORMAT) : null] : null
                });
              }}
              format={DATE_FORMAT}
              allowClear={false}
              
            />
          </Col>
          <Col xs={24} md={12} lg={6}>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '4px' }}>Search</label>
            <Input
              placeholder="Search"
              value={filters.batchCode}
              onChange={(e) => {
                const val = e.target.value;
                setFilters(prev => ({ ...prev, batchCode: val }));
                updateFilters({ batchCode: val });
              }}
            />
          </Col>
          <Col xs={24} md={12} lg={6}>
            <Space style={{ width: '100%', marginTop: '25px' }}>
              <Button
                type="primary"
                icon={<SearchOutlined />}
              >
                Search
              </Button>
            </Space>
          </Col>
        </Row>
      </Card>
      <div >
        <Table
          dataSource={cycleCounts}
          columns={CycleColumns}
          pagination={false}
          bordered
          scroll={{ x: 'max-content'}}
          footer={() => `List of Cycle Counts - Total Records: ${cycleCounts?.length === 0 ? "0" : cycleCounts?.length}`}
          rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
        />
      </div>

      <ProductInfoModal
        visible={modalVisibleProduct}
        onCancel={handleModalCancelProduct}
        selectedItemDetails={selectedProductDetails}
        selectedItems={selectedProductDetails?.productDetails}
        selectedRecord={selectedProductDetails?.selectedRecord}
      />
    </DataSheet>
  )
}

export default CycleCountList
